<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span  class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption }} </span>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <div class="p-2" v-html="$t('developement.detail')"></div>
          </CCol>
        </CRow>

        <CRow v-for="objs in mapping.mapping" :key="'control'+mapping">
          <CCol col="12">
            <LearningOutcomeReports :type="objs.title.filter(item => { return (item.key == lang) })[0].value" :items="objs.value" @onEdit="onEditInfomation"></LearningOutcomeReports>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import LearningOutcome from "@/projects/views/E-Port/components/LearningOutcome/LearningOutcome";
import MethodAssessment from "@/projects/views/E-Port/components/LearningOutcome/MethodAssessment";
import LearningOutcomeReports from "@/projects/views/E-Port/components/Mapping/components/LearningOutcomeReports";
export default {
  name: 'MappingReports',
  components: {LearningOutcomeReports, MethodAssessment, LearningOutcome},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    disable: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Boolean,
      default: false
    },
  },

  data: function () {
    return {
      learningOutcomes : {},
      // learningOutcomes : {
      //   id : "",
      //   mapping : [
      //     {
      //       title : [
      //         {key:"en", value:"1. Ethics and Morality"},
      //       ],
      //       value : [
      //         {
      //           plo:"1.1 ความซื่อสัตย์",
      //           teaching:"ไม่มีการทุจริตในการสอบ\n" + "ไม่มีประวัติ/เรื่องร้องเรียน ความไม่ซื่อสัตย์.\n"  + "Timeliness of the works submission.",
      //           methods: [ { "title": "360", "value": [ { "type": "number", "title": "DEFUALT", "value": "1" }, { "type": "number", "title": "MAX", "value": 25 } ], "subTitle": "Setting", "control": [ { "type": "number", "title": "Medium", "value": 40 }, { "type": "number", "title": "Medium", "value": 60 }, { "type": "number", "title": "Average", "value": 80 } ] } ],
      //           action:true,
      //           fields:[],
      //           students:[{
      //             infomation:{
      //               firstName:"Saksith",
      //               lastName:"Rittanasatheiyn"
      //             },
      //             code:"61360",
      //             avata:"",
      //             type:"",
      //             value:{}
      //           }]
      //         },
      //         {
      //           plo:"1.2 ปฏิบัติตามจรรยาบรรณวิชาชีพแพทย์",
      //           teaching:"ไม่มีการทุจริตในการสอบ\n" +
      //               "ไม่มีประวัติ/เรื่องร้องเรียน ความไม่ซื่อสัตย์.\n"  +
      //               "Timeliness of the works submission.",
      //           assessment:"ไม่ผ่าน: มีเรื่องร้องเรียน (ที่สมเหตุผล) หรือทุจริต (สีแดง)\n" +
      //               "ผ่าน: ไม่มีเรื่องร้องเรียน (ที่สมเหตุผล) หรือทุจริต (สีเขียว)\n",
      //           methods: [],
      //           action:true,
      //           fields:[],
      //           students:[{
      //             infomation:{
      //               firstName:"Saksith",
      //               lastName:"Rittanasatheiyn"
      //             },
      //             code:"61360131",
      //             avata:"",
      //             type:"",
      //             value:{}
      //           }]
      //         },
      //         {
      //           plo:"1.3 ความตรงต่อเวลา",
      //           teaching:"การเข้าเรียน/มาปฏิบัติงาน/เข้าเวรตรงเวลา /การส่งงาน",
      //           assessment:"ไม่ผ่าน: เข้าเรียนน้อยกว่า 80% หรือส่งงานล่าช้า (สีแดง)\n" +
      //               "ผ่าน: เข้าเรียน 80% ขึ้นไป และส่งงานตามกำหนด (สีเขียว)\n",
      //
      //           methods: [],
      //           action:true,
      //           fields:[],
      //           students:[{
      //             infomation:{
      //               firstName:"Saksith",
      //               lastName:"Rittanasatheiyn"
      //             },
      //             code:"61360131",
      //             avata:"",
      //             type:"",
      //             value:{}
      //           }]
      //         }
      //       ]
      //     }
      //   ]
      // },

      isDialog:false,
      method : [],



    }
  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
      this.onLoad();
    },

    onLoad(){
      var data = {};
      this.$store.dispatch("EProtMapping/mappings", data)
    },

    onSelectMethod(value, e) {
      this.item.mapping.methods = [];
      this.item.mapping.methods.push(value);
    },
  },

  computed:{
    ...mapGetters({
      lang: "setting/lang",
      mapping : "EProtMapping/mappings"
    })
  },

  watch: {
  }
}
</script>
<style>

.w50{
  min-width: 50%;
}
.input-group-append .form-group {
  margin-bottom: 0px;
}
.text-right{
  text-align: end;
}
.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
